import * as React from 'react';
import Dropzone from '../Dropzone';

class ImageUpload extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <Dropzone
                actionUrl={`${apiUrl}/views/templates/uploadfile`}
                upload={this.props.upload}
                onFileUploadCompleted={this.props.onUploadCompleted}
                acceptedFiles={'image/jpeg,image/png,image/gif,application/pdf'}
            />
        );
    }
}

export default ImageUpload;
